import { render, staticRenderFns } from "./EditContentPropertiesButton.vue?vue&type=template&id=52e906a3&"
import script from "./EditContentPropertiesButton.vue?vue&type=script&lang=ts&"
export * from "./EditContentPropertiesButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports